import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiConfiguration } from '../api-configuration';
import { BaseService } from '../base-service';
import { Channel } from '../models/channels';
import { IdName } from '@api/models/idname';
import { ChannelListResponse } from '@app/admin/channel/model/channel.model';

@Injectable({
  providedIn: 'root',
})
export class ChannelsApi extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  static readonly ChannelsPath = '/channels';

  getChannels(params?): Observable<any> {
    return this.http.get(`${this.rootUrl}${ChannelsApi.ChannelsPath}`, params ? { params } : {});
  }

  getChannelsList(params?): Observable<ChannelListResponse> {
    return this.http.get<ChannelListResponse>(`${this.rootUrl}${ChannelsApi.ChannelsPath}/channels-list`, params ? { params } : {});
  }

  saveChannel(channel): Observable<any> {
    return this.http.post<Channel>(`${this.rootUrl}${ChannelsApi.ChannelsPath}`, channel);
  }

  editChannel(channel): Observable<any> {
    return this.http.put<Channel>(`${this.rootUrl}${ChannelsApi.ChannelsPath}`, channel);
  }

  getChannelById(channelId: number): Observable<any> {
    return this.http.get(`${this.rootUrl}${ChannelsApi.ChannelsPath}/${channelId}`);
  }

  deleteChannel(channelId: number): Observable<any> {
    return this.http.delete(`${this.rootUrl}${ChannelsApi.ChannelsPath}/${channelId}`);
  }

  getChannelListForContactPersons(customerIds: number[]): Observable<IdName[]> {
    return this.http.get<IdName[]>(`${this.rootUrl}${ChannelsApi.ChannelsPath}/channels-with-contact-persons`, { params: { customerIds } });
  }

  getLineOfBusinessList(): Observable<IdName[]> {
    return this.http.get<IdName[]>(`${this.rootUrl}${ChannelsApi.ChannelsPath}/line-of-business-list`);
  }

  getChannelOptions(customerIds: number[]): Observable<IdName[]> {
    return this.http.get<IdName[]>(`${this.rootUrl}${ChannelsApi.ChannelsPath}/options`, { params: { customerIds } });
  }

  // GET /Channels/options-by-country
  getChannelOptionsByCountry(customerIds: number[], countries: string[]): Observable<IdName[]> {
    return this.http.get<IdName[]>(`${this.rootUrl}${ChannelsApi.ChannelsPath}/options-by-country`, {
      params: {
        customerIds,
        countries,
      },
    });
  }
}
